import { USER_LOGIN, USER_LOGOUT } from "../Types/types";

const initState = {
  userId: "",
  userToken: "",
  userRefreshToken: "",
  role: "",
  isUser: false,
};

const UserReducer = (state = initState, action) => {
  switch (action.type) {
    case USER_LOGIN:
      return {
        ...state,
        userId: action.userId,
        userToken: action.payload,
        userRefreshToken: action.refreshToken,
        role: action.role,
        isUser: true,
      };

    case USER_LOGOUT:
      return {
        ...state,
        userId: "",
        userToken: "",
        userRefreshToken: "",
        role: "",
        isUser: false,
      };

    default:
      return state;
  }
};

export default UserReducer;
